import { UnstyledButton } from './Button';
import UnorderedList from './UnorderedList';
import Heading from './Heading';

export const Unstyled = {
  Heading,
  Button: UnstyledButton,
  UnorderedList,
};
